'use strict';

// @flow
import environmentInfo from '../../../helper/environmentInfo';

function ToolsetFinishDialogController($scope, $rootScope, $filter, $mdDialog, Auth, Canvas, SubmitLayout, log, Rollbar) {
  'ngInject';

  $scope.isLoading = false;
  $scope.isSaveButtonEnabled = true;
  $scope.request = {};

  const user = Auth.getCurrentUserSync();
  $scope.request.nameField = user.name;

  if (user.eventDate) {
    $scope.request.dateField = new Date(user.eventDate);
  }

  $scope.save = function () {
    $rootScope.saveCanvasFile();
    $scope.isSaveButtonEnabled = false;
  };
  $scope.hide = function () {
    $mdDialog.hide();
  };
  $scope.cancel = function () {
    $mdDialog.cancel();
  };
  $scope.sendOrder = function (isValid) {
    if (!isValid) return;

    $scope.isLoading = true;
    let layoutSerialized;

    try {
      layoutSerialized = Canvas.serializeCanvas();
      log(layoutSerialized);
    } catch (e) {
      Rollbar.error(e);
      $scope.isLoading = false;
      alert('Beim Übertragen des Bildmotivs ist leider ein Fehler aufgetreten. Bitte speichere Dein Bildmotiv und sende es per E-Mail an kontakt@knips-o-mat.de');
      $mdDialog.cancel();
      return;
    }

    setTimeout(function () {
      try {
        let stageConfig = Canvas.getStageConfig();
        let stageJson = btoa(Canvas.saveCanvasToJson());

        let request = new SubmitLayout({
          layoutName: stageConfig.layoutName,
          customer: $scope.request.nameField,
          date: $filter('date')($scope.request.dateField, 'dd-MM-yyyy'),
          layout: layoutSerialized,
          saveFile: stageJson,
          environmentInfo: environmentInfo()
        });

        request.$save(
          function (u, putResponseHeaders) {
            log(u);

            $scope.isLoading = false;
            $mdDialog.hide('send');

            if (u.isSuccess) {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('#popupContainer')))
                  .clickOutsideToClose(true)
                  .title('Fertig')
                  .textContent('Das Layout wurde erfolgreich übertragen.')
                  .ok('Ok')
              );
            } else {
              $mdDialog.show(
                $mdDialog
                  .alert()
                  .parent(angular.element(document.querySelector('#popupContainer')))
                  .clickOutsideToClose(true)
                  .title('Layout konnte nicht gesendet werden')
                  .textContent(u.status)
                  .ok('Ok')
              );
            }
          },
          function (err) {
            $mdDialog.show(
              $mdDialog
                .alert()
                .parent(angular.element(document.querySelector('#popupContainer')))
                .clickOutsideToClose(true)
                .title('Layout konnte nicht gesendet werden')
                .textContent(u.status)
                .ok('Ok')
            );
          }
        );
      } catch (e) {
        Rollbar.critical(e, {
          stageConfig,
          stageJson,
          environmentInfo: environmentInfo()
        });
        console.error(e);

        alert('Beim Übertragen des Bildmotivs ist leider ein Fehler aufgetreten. Bitte speichere Dein Bildmotiv und sende es per E-Mail an kontakt@knips-o-mat.de');
        $mdDialog.cancel();
      }
    }, 500);
  };
}

export default class FinishController {
  $state
  $scope
  $rootScope
  $mdDialog
  $mdMedia
  $filter
  submitLayout
  canvas

  /*@ngInject*/
  constructor($state, $scope, $rootScope, $mdDialog, $mdMedia, $filter, SubmitLayout, Canvas) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$mdDialog = $mdDialog;
    this.$mdMedia = $mdMedia;
    this.$filter = $filter;
    this.submitLayout = SubmitLayout;
    this.canvas = Canvas;
  }

  $onInit = () => { }

  showFinishOption = ev => {
    const showSubmitDialog = () => {
      const useFullScreen = this.$mdMedia('sm') || this.$mdMedia('xs');

      this.$mdDialog
        .show({
          controller: ToolsetFinishDialogController,
          template: require('./finish.dialog.html'),
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true,
          fullscreen: useFullScreen,
          locals: {
            log: this.$rootScope.log
          }
        })
        .then(action => { }, () => { });
      this.$scope.$watch(() => {
        return this.$mdMedia('xs') || this.$mdMedia('sm');
      });
    };

    const canvasConfig = this.canvas.getStageConfig();

    if (!canvasConfig.layoutName || canvasConfig.layoutName === 'n/a') {
      this.$mdDialog.show(
        this.$mdDialog
          .alert()
          .parent(angular.element(document.querySelector('#popupContainer')))
          .clickOutsideToClose(true)
          .title('Achtung')
          .textContent('Bitte wähle zuerst ein Layout aus.')
          .ok('Ok')
      );
      return;
    }

    if (this.canvas.isEmpty()) {
      this.$mdDialog
        .show(
          this.$mdDialog
            .confirm()
            .parent(angular.element(document.querySelector('#popupContainer')))
            .clickOutsideToClose(true)
            .title('Leeres Bildmotiv')
            .htmlContent(
              '<p>Dein Bildmotiv ist aktuell leer. Möchtest du ein <strong>leeres Bildmotiv senden?</strong></p>' +
              '<p>(Klicke auf "Nein", um einen Hintergrund festzulegen oder Text hinzuzufügen. Klicke auf "Ja, senden", um dein Bildmotiv jetzt zu senden.)</p>'
            )
            .ok('Ja, senden')
            .cancel('Nein, ich möchte es noch bearbeiten')
        )
        .then(() => showSubmitDialog())
        .catch(() => { });
      return;
    }

    showSubmitDialog();
  }
}



// WEBPACK FOOTER //
// ./client/app/configurator/finish/finish.controller.js